import { STORAGE_KEY } from '@/constants/storage';
import en from './locales/en';
import km from './locales/km';
import VueCookies from 'vue-cookies';

const locale = VueCookies.get(STORAGE_KEY.LOCALE) || 'en';

export default {
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en,
        km,
    },
};
